import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Custom global styles
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Add viewport meta tag dynamically for mobile optimization
const addViewportMetaTag = () => {
  const metaTag = document.createElement("meta");
  metaTag.name = "viewport";
  metaTag.content = "width=device-width, initial-scale=1.0";
  document.head.appendChild(metaTag);
};

// Initialize app with mobile compatibility
const root = ReactDOM.createRoot(document.getElementById("root"));
addViewportMetaTag();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
